// extracted by mini-css-extract-plugin
module.exports = {"cityList":"CityList_cityList__gakso","city":"CityList_city__CMJ5g","regionTitle":"CityList_regionTitle__eJHtj","link":"CityList_link__xQ3Sf"};